import React from 'react'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'

import { ChargePointCapiPage } from '../../../support/pages/charge-point-capi-page'
import Text from '../../../ui/Text'
import { ChargePointContextProvider } from '../../context/ChargePointContext'
import { useChargePointGetQuery } from '../../redux/api/web-api'
import { ChargePointPageControls } from '../../features/charge-point-page-controls'
import { ChargePointOcppPage } from '../charge-point-ocpp-page'

const SExternalChargerMessageWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
`

const SExternalChargerMessage = styled.div`
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
    text-align: center;
    width: 310px;
`

const SContainer = styled.div`
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    background-color: #ffffff;
    border: none;

    @media (min-width: 990px) {
        width: 970px;
    }

    @media (min-width: 1200px) {
        width: 90vw;
        max-width: 1400px;
    }
`

export function ChargePointDetailsPage(): React.ReactElement {
    const chargePointId = useParams().chargePointId

    const { data: chargePoint, isLoading } = useChargePointGetQuery(
        {
            chargePointId,
            expand: 'additionalInfo,scheduleInfo,wifisignal',
        },
        {
            skip: !chargePointId,
            refetchOnFocus: true,
        }
    )

    return (
        <SContainer>
            {chargePoint ? (
                <>
                    <ChargePointContextProvider>
                        <ChargePointPageControls chargePoint={chargePoint} />
                        {chargePoint?.ocppServerMode === 'None' && (
                            <ChargePointCapiPage chargePoint={chargePoint} isLoading={isLoading} />
                        )}
                        {chargePoint?.ocppServerMode === 'Internal' && (
                            <ChargePointOcppPage chargePoint={chargePoint} isLoading={isLoading} />
                        )}
                        {chargePoint?.ocppServerMode === 'External' && (
                            <div>
                                <SExternalChargerMessageWrapper>
                                    <SExternalChargerMessage>
                                        <Text
                                            code="msgChargerIsDeployedToExternalPart"
                                            values={{ chargePointId: chargePoint.id }}
                                        />
                                    </SExternalChargerMessage>
                                </SExternalChargerMessageWrapper>
                            </div>
                        )}
                    </ChargePointContextProvider>
                </>
            ) : null}
        </SContainer>
    )
}
